import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getAuth, signInWithEmailAndPassword, signInWithCustomToken } from 'firebase/auth';
import { useAuthState } from 'react-firebase-hooks/auth';
import { initializeApp } from 'firebase/app';
import { exchangeToken, authChecked } from '../actions/associatesActions';
import axios from 'axios';
import parseJwt from '../helpers/parseJwt';
const firebaseConfig = JSON.parse(process.env.REACT_APP_FIREBASE);
const AuthContext = createContext(null);
const firebaseApp = initializeApp(firebaseConfig);

export function AuthProvider({ externalAppToken, children }) {
  const dispatch = useDispatch();
  const userApp = useSelector((s) => s.associates);
  const app = useSelector((s) => s.app);
  const loading = useSelector((s) => s.associates.loading);
  const auth = getAuth();
  const [user] = useAuthState(auth);

  useEffect(() => {
    if (externalAppToken) {
      checkExternalAppToken();
    } else if (auth._isInitialized && !user) {
      dispatch(authChecked());
    }
  }, [auth._isInitialized]);

  useEffect(() => {
    if (user && app.isPlatform !== undefined && !externalAppToken) {
      exchangeToken(dispatch, user, null, null, app.isPlatform);
    }
  }, [user, app?.isPlatform]);

  const login = async (email, password, tenantId, callback) => {
    const auth = getAuth();
    auth.tenantId = tenantId;

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      exchangeToken(dispatch, userCredential.user, callback);
    } catch (error) {
      throw error;
    }
  };

  // used for external apps like rezer, wr, etc
  const checkExternalAppToken = async () => {
    const welletApi = process.env.REACT_APP_SALES_API_URL;
    const response = await axios.get(
      `${welletApi}/users/external-app/token?token=${externalAppToken}`,
    );
    if (response.data.isValid) {
      const tokenDetails = parseJwt(response.data.customToken);
      auth.tenantId = tokenDetails.tenant_id;
      const userCredentials = await signInWithCustomToken(auth, response.data.customToken);
      exchangeToken(
        dispatch,
        userCredentials.user,
        () => {},
        window.decodeURIComponent(externalAppToken),
      );
    }
  };

  const logout = () => {
    // Limpiar token (cookies/secure storage) si corresponde
    //dispatch(logoutAction());
  };

  const value = useMemo(
    () => ({
      user: userApp,
      loading,
      login,
      logout,
    }),
    [userApp, loading],
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
